import React from "react";

const Textarea = ({ rows, cols, id }) => {
  return <textarea name="" id={id} cols={cols} rows={rows}></textarea>;
};

export default Textarea;
